import { Alert, Backdrop, Snackbar } from '@mui/material';
import { useEffect } from 'react';
// @mui
import { toast } from 'react-toastify';
// utils

// ----------------------------------------------------------------------

export default function Notification({ notification, setNotification, errors, handleClosed, onCloseRedirect }) {
    useEffect(() => {
        if (notification?.open && notification?.msg) {
            toast[notification?.type || 'success'](notification?.msg, {
                onClose: () => handleClosed ? handleClosed() : setNotification && setNotification(prev => ({ ...prev, open: false })),
            });
        }
    }, [notification?.open, notification?.msg, notification?.type, setNotification, handleClosed]);

    const handleClose = () => {
        handleClosed ? handleClosed() : setNotification && setNotification(prev => ({ ...prev, open: false }));
        // onCloseRedirect && onCloseRedirect();
    }

    const normalizeErrorMessage = (message, fieldPath = '') => {
        if (typeof message !== 'string') {
            return message;
        }

        // Only strip `field_name: message` style prefixes.
        if (fieldPath && message.startsWith(`${fieldPath}: `)) {
            return message.slice(fieldPath.length + 2);
        }

        return message.replace(/^[A-Za-z0-9_.-]+:\s+/, '');
    };

    const flattenErrorMessages = (source, fieldPath = '') => {
        if (!source) {
            return [];
        }

        if (Array.isArray(source)) {
            return source.flatMap((item) => flattenErrorMessages(item, fieldPath));
        }

        if (typeof source === 'string') {
            return [normalizeErrorMessage(source, fieldPath)];
        }

        if (typeof source === 'object') {
            return Object.entries(source).flatMap(([key, value]) => {
                const nextFieldPath = fieldPath ? `${fieldPath}.${key}` : key;
                return flattenErrorMessages(value, nextFieldPath);
            });
        }

        return [String(source)];
    };

    const errorItems = flattenErrorMessages(errors).filter(Boolean);

    return (
        // <div>
        //     <ToastContainer
        //         position="top-center"
        //         // autoClose={5000}
        //         hideProgressBar={false}
        //         newestOnTop={true}
        //         closeOnClick={true}
        //         // rtl={false}
        //         // pauseOnFocusLoss
        //         // draggable
        //         // pauseOnHover
        //         // theme="light"
        //     // transition={Bounce}
        //     />
        // </div>
        <>
            <Backdrop
                open={notification.open}
                onClick={handleClose}
                sx={{
                    zIndex: (theme) => theme.zIndex.snackbar - 1,
                    backgroundColor: 'rgba(0, 0, 0, 0.35)',
                }}
            />
            <Snackbar
                open={notification.open}
                autoHideDuration={5000}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: "top",
                    horizontal: "center",
                }}
                sx={{
                    top: "50% !important",
                    left: "50% !important",
                    transform: "translate(-50%, -50%) !important",
                }}
            >
                <Alert
                    severity={notification.type || "success"}
                    onClose={handleClose}
                    sx={{
                        minWidth: 320,
                        maxWidth: "90vw",
                        width: "fit-content",
                        textAlign: "center",
                        boxShadow: "0 14px 40px rgba(0,0,0,0.25)",
                        borderRadius: 2,
                    }}
                >
                    {notification.msg}

                    {errorItems.length > 0 && (
                        <div style={{ marginTop: 8 }}>
                            {errorItems.map((error, index) => (
                                <div key={index}>{error}</div>
                            ))}
                        </div>
                    )}
                </Alert>
            </Snackbar>
        </>
    );
}

